/* eslint-disable */
import React, { useState, useEffect } from "react";
import { db, storage } from "../../firebase-config";
import { useParams, useNavigate, Link } from "react-router-dom";
import { ref, onValue, set } from "firebase/database";
import { ref as storageRef, uploadBytes, getDownloadURL, deleteObject, listAll } from "firebase/storage";
import { ToastContainer, toast } from "react-toastify";
import "./UpdatePageDoc.css";

const initialState = {
  Email: "",
  Password: "",
  ID: "",
  Name: "",
  Role: "",
};

function UpdatePageDoc() {
  const [state, setState] = useState(initialState);
  const [data, setData] = useState({});
  const [actualDoctorKey, setActualDoctorKey] = useState("");
  const [signatureFile, setSignatureFile] = useState(null);
  const [signatureFileName, setSignatureFileName] = useState("");
  const [currentSignatureURL, setCurrentSignatureURL] = useState("");
  const [originalID, setOriginalID] = useState(""); // Track original ID for signature folder updates
  const [originalName, setOriginalName] = useState(""); // Track original Name for signature folder updates

  const { ID, Name, Role, Email, Password } = state;

  const navigate = useNavigate();
  const { id } = useParams();

  //   const auth = getAuth();
  //   const user = auth.currentUser;

  var adminName1 = localStorage.getItem("adminName");

  useEffect(() => {
    const users = ref(db, `superadmin/admins/${adminName1}/doctors`);
    onValue(users, (snapshot) => {
      if (snapshot.exists()) {
        const doctorsData = snapshot.val();
        setData({ ...doctorsData });
      } else {
        setData({});
      }
    });
    return () => {
      setData({});
    };
  }, [id, adminName1]);

  useEffect(() => {
    if (id) {
      // First try exact match
      let doctorData = data[id];
      let actualKey = id;
      
      // If exact match fails, try to find a key that matches when trimmed
      if (!doctorData) {
        const availableKeys = Object.keys(data);
        
        // Look for keys that match when trimmed or with slight variations
        const matchingKey = availableKeys.find(key => {
          const trimmedKey = key.trim();
          const trimmedId = id.trim();
          return trimmedKey === trimmedId || 
                 key === trimmedId || 
                 trimmedKey === id;
        });
        
        if (matchingKey) {
          doctorData = data[matchingKey];
          actualKey = matchingKey;
        }
      }
      
      // Store the actual key for use in form submission
      setActualDoctorKey(actualKey);
      
      if (doctorData) {
        setState({ ...doctorData });
        // Store original ID and Name for signature folder tracking
        setOriginalID(doctorData.ID || "");
        setOriginalName(doctorData.Name || "");
        // Load current signature URL if exists
        if (doctorData.SignatureURL) {
          setCurrentSignatureURL(doctorData.SignatureURL);
        }
      } else {
        setState({ ...initialState });
        setOriginalID("");
        setOriginalName("");
      }
    } else {
      setState({ ...initialState });
    }

    return () => {
      setState({ ...initialState });
    };
  }, [id, data]);


  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setState({ ...state, [name]: value });
  };

  // Function to handle signature file upload
  const handleSignatureUpload = (event) => {
    const file = event.target.files[0];
    if (file) {
      // Check if it's an image file
      if (file.type.startsWith('image/')) {
        setSignatureFile(file);
        setSignatureFileName(file.name);
      } else {
        toast.error("Please select an image file for signature", {
          position: "top-center",
        });
        event.target.value = ""; // Clear the input
      }
    }
  };

  // Function to move signature folder when ID or Name changes
  const moveSignatureFolder = async (oldName, oldId, newName, newId) => {
    try {
      console.log("Moving signature folder from:", `${oldName}+${oldId}`, "to:", `${newName}+${newId}`);
      
      const oldFolderPath = `superadmin/admins/${adminName1}/DoctorSignature/${oldName}+${oldId}/`;
      const newFolderPath = `superadmin/admins/${adminName1}/DoctorSignature/${newName}+${newId}/`;
      
      const oldFolderRef = storageRef(storage, oldFolderPath);
      
      // List all files in the old folder
      let existingFiles;
      try {
        existingFiles = await listAll(oldFolderRef);
      } catch (error) {
        console.log("No existing signature folder found");
        return null; // No old folder exists
      }
      
      if (existingFiles.items.length === 0) {
        console.log("No signature files found in old folder");
        return null; // No files to move
      }
      
      let newSignatureURL = null;
      
      // Move each file from old folder to new folder
      for (const item of existingFiles.items) {
        try {
          // Get the file name
          const fileName = item.name;
          
          // Download the file
          const downloadURL = await getDownloadURL(item);
          const response = await fetch(downloadURL);
          const blob = await response.blob();
          
          // Upload to new location
          const newFilePath = `${newFolderPath}${fileName}`;
          const newFileRef = storageRef(storage, newFilePath);
          await uploadBytes(newFileRef, blob);
          
          // Get new download URL
          newSignatureURL = await getDownloadURL(newFileRef);
          
          console.log(`Moved file: ${fileName} to new location`);
        } catch (error) {
          console.error(`Error moving file ${item.name}:`, error);
        }
      }
      
      // Delete old folder files
      try {
        await Promise.all(
          existingFiles.items.map(item => deleteObject(item))
        );
        console.log("Deleted old signature folder");
      } catch (deleteError) {
        console.error("Error deleting old folder:", deleteError);
      }
      
      return newSignatureURL;
    } catch (error) {
      console.error("Error moving signature folder:", error);
      throw error;
    }
  };

  // Function to upload signature image to Firebase Storage (with replacement)
  const uploadSignatureImage = async (file, doctorFullName, doctorId) => {
    try {
      const folderPath = `superadmin/admins/${adminName1}/DoctorSignature/${doctorFullName}+${doctorId}/`;
      const folderRef = storageRef(storage, folderPath);
      
      // Delete existing signature images in the folder
      try {
        const existingFiles = await listAll(folderRef);
        if (existingFiles.items.length > 0) {
          await Promise.all(
            existingFiles.items.map(item => deleteObject(item))
          );
        }
      } catch (deleteError) {
        // Silently handle deletion errors (folder might not exist yet)
      }
      
      // Upload the new signature
      const fileName = `${file.name}`;
      const imagePath = `${folderPath}${fileName}`;
      const imageRef = storageRef(storage, imagePath);
      
      // Upload the file
      const snapshot = await uploadBytes(imageRef, file);
      
      // Get the download URL
      const downloadURL = await getDownloadURL(snapshot.ref);
      
      return downloadURL;
    } catch (error) {
      throw error;
    }
  };

  const notifySuccess = () =>
    toast.success("Doctors Information Updated Successfully", {
      position: "top-center",
    });

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!Name || !ID || !Role) {
      toast.error("Please provide value in each field", {
        position: "top-center",
      });
    } else {
      const keyToUse = actualDoctorKey || id;
      let updatedState = { ...state };
      
      // Check if ID or Name has changed and if there's an existing signature
      const idChanged = originalID && ID !== originalID;
      const nameChanged = originalName && Name !== originalName;
      const hasExistingSignature = currentSignatureURL && !signatureFile;
      
      console.log("Update check:", { 
        idChanged, 
        nameChanged, 
        hasExistingSignature,
        originalID,
        newID: ID,
        originalName,
        newName: Name,
        Role
      });
      
      // If HOD role and (ID or Name changed) and existing signature, move the signature folder
      if (Role === "HOD" && (idChanged || nameChanged) && hasExistingSignature) {
        try {          
          const newSignatureURL = await moveSignatureFolder(originalName, originalID, Name, ID);
          
          if (newSignatureURL) {
            updatedState.SignatureURL = newSignatureURL;
            console.log("Signature folder moved successfully. New URL:", newSignatureURL);
          } else {
            console.log("No signature found to move");
          }
        } catch (error) {
          console.error("Error moving signature folder:", error);
          toast.error("Failed to update signature folder location", {
            position: "top-center",
          });
          return; // Stop the update process if signature move fails
        }
      }
      
      // If HOD role and new signature file uploaded, upload the signature
      if (Role === "HOD" && signatureFile) {
        try {
          const signatureURL = await uploadSignatureImage(signatureFile, Name, ID);
          updatedState.SignatureURL = signatureURL;
        } catch (error) {
          toast.error("Failed to upload signature image", {
            position: "top-center",
          });
          return; // Stop the update process if signature upload fails
        }
      }
      
      set(
        ref(db, `superadmin/admins/${adminName1}/doctors/${keyToUse}`),
        updatedState,
        (err) => {
          if (err) {
            toast.error(err, {
              position: "top-center",
            });
          } else {
            toast.success("Doctors Information Updated Successfully", {
              position: "top-center",
            });
          }
        }
      );

      notifySuccess();
      setTimeout(function () {
        // navigate("/Admin/ViewAll");
        navigate("/Admin");
      }, 2100);
    }
  };
  // change for new layout 14 jan
  return (
    <>


<div className="techsidebar"></div>


<div className="top-nav">
<h1
 style={{
   fontSize: "28px",
   textDecoration: "underline",
   marginRight: "15%",
   marginBottom: "2%",
 }}
>
Update Doctor's Information
</h1>

{/* <Button
 variant="primary"
 onClick={handleLogout}
 className="logout-button"
>
 <i className="fas fa-power-off logout-icon"></i>
</Button> */}
</div>

<Link to="/Admin" className="homeButton">
<span id="backText" className="backText">
 Back
</span>
<i id="backIcon" className="fas fa-long-arrow-alt-left fa-lg fa-2x"></i>
</Link>
    

      <div className="DocUpdateDiv" style={{ marginTop: "100px" }}>
{/* deepa css */}
      <form  className="signupForm2 PatientData-container"

          onSubmit={handleSubmit} > 
    
          <strong className="strongaddadmin">Doctor's Name:</strong>
          <input
            className="inputaddadmin "
            type="text"
            id="Name"
            name="Name"
            placeholder="Doctor's Name"
            value={Name || ""}
            onChange={handleInputChange}
          />

          <strong className="strongaddadmin">ID:</strong>
          <input
            className="inputaddadmin "
            type="text"
            id="ID"
            name="ID"
            placeholder="ID"
            value={ID || ""}
            onChange={handleInputChange}
          />

          <strong className="strongaddadmin">Email ID:</strong>
          <input
            className="inputaddadmin inputPN "
            type="text"
            id="Email"
            name="Email"
            placeholder="Email-ID"
            value={Email || ""}
            readOnly
            onChange={handleInputChange}
          />

          <strong className="strongaddadmin">Password:</strong>
          <input
            className="inputaddadmin inputPN"
            type="text"
            id="Password"
            name="Password"
            placeholder="Password"
            value={Password || ""}
            readOnly
            onChange={handleInputChange}
          />

          <strong className="strongaddadmin">Role:</strong>
          <input
            className="inputaddadmin inputPN "
            type="text"
            id="Role"
            name="Role"
            placeholder="Role"
            value={Role || ""}
            readOnly
            onChange={handleInputChange}
          />

          {/* Upload Signature field - only visible for HOD role */}
          {Role === "HOD" && (
            <>
              <strong className="strongaddadmin">UPLOAD SIGNATURE</strong>
              <div style={{ display: "flex", alignItems: "center", gap: "10px", marginBottom: "15px" }}>
                <input
                  type="file"
                  accept="image/*"
                  onChange={handleSignatureUpload}
                  style={{ display: "none" }}
                  id="signature-upload"
                />
                <label
                  htmlFor="signature-upload"
                  className="inputaddadmin"
                  style={{
                    cursor: "pointer",
                    backgroundColor: "#f8f9fa",
                    border: "1px solid #ced4da",
                    padding: "8px 12px",
                    borderRadius: "4px",
                    display: "inline-block",
                    textAlign: "center",
                    minHeight: "38px",
                    lineHeight: "22px",
                    width: "auto",
                    minWidth: "200px"
                  }}
                >
                  {signatureFileName || "Choose Signature Image"}
                </label>
                {signatureFileName && (
                  <span style={{ color: "#28a745", fontSize: "14px" }}>
                    ✓ New File Selected
                  </span>
                )}
                {currentSignatureURL && !signatureFileName && (
                  <span style={{ color: "#007bff", fontSize: "14px" }}>
                    ✓ Current Signature Available
                  </span>
                )}
              </div>
            </>
          )}
{/* deepa css change class name */}
          <input className="addimagebtn" type="submit" value="Save" />
          <ToastContainer />
        </form>
      </div>
    </>
  );
}

export default UpdatePageDoc;
